import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBackToBottomLeft = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 18.0021H20V6.00208H4V12.2589L2 14.2589V4.00208H22V20.0021H2.5V18.0021Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M6 15.5021L2.5 19.0021L6 22.5021", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBackToBottomLeft.js.map